import axios from "axios";
import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import DaumPostCode from "react-daum-postcode";
import { useLocation } from "react-router-dom";
import { root_url } from "../setting";
import { getBearerString } from "../utils/Auth";
import { Runner, setJoiner } from "../utils/class_module";

const AdminApplicationGroup = () => {
  const location = useLocation();
  // joinSeq가 있는 경우, 수정
  const queryParams = new URLSearchParams(location.search);
  const joinSeq = queryParams.get("joinSeq");

  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [runnerList, setRunnerList] = useState([]);
  useEffect(() => {
    // setCheckRunnerInd([false,])
    const check_list = [];
    runnerList.forEach((e) => check_list.push(false));
    setCheckRunnerInd(check_list);
  }, [runnerList.length]);

  const [ticketInfo, setTicketInfo] = useState([]);
  const [today, setToday] = useState(new Date());
  const [checkRunnerInd, setCheckRunnerInd] = useState([]);
  const [giftOptionList, setGiftOptoinList] = useState([]);
  const [onUpdate, setOnUpdate] = useState(false);
  const [onUpdateRunnerInd, setOnUpdateRunnerInd] = useState();

  /* joiner form state */
  const [joinerSeq, setJoinerSeq] = useState(0);
  const [exponent, setExponent] = useState("");
  const [joinerName, setJoinerName] = useState("");
  const [joinerPhoneNum, setJoinerPhoneNum] = useState("");
  const [address, setAddress] = useState({
    zonecode: "",
    roadAddress: "",
    buildingName: "",
  });
  const [detailAddress, setDetailAddress] = useState("");
  const [popupShow, setPopupShow] = useState(false);
  const onCompletePostCode = ({ zonecode, roadAddress, buildingName }) => {
    setPopupShow(false);
    setAddress({
      zonecode,
      roadAddress,
      buildingName,
    });
  };
  /* joiner payment state */
  const [joinerPaymentStatus, setJoinerPaymentStatus] = useState("");
  const [joinerPaymentType, setJoinerPaymentType] = useState("");

  /* runner form state */
  const [runnerName, setRunnerName] = useState("");
  const [runnerBirthday, setRunnerBirthday] = useState("");
  const [runnerGender, setRunnerGender] = useState("M");
  const [runnerPhoneNum, setRunnerPhoneNum] = useState("");
  const [runnerCourse, setRunnerCourse] = useState(0);
  const [runnerGift, setRunnerGift] = useState("티셔츠");
  const [runnerGiftOption, setRunnerGiftOption] = useState("110");

  /* runner update */
  const [insRunnerList, setInsRunnerList] = useState([]);
  const [delRunnerList, setDelRunnerList] = useState([]);
  const [updRunnerList, setUpdRunnerList] = useState([]);

  useEffect(() => {
    if (joinSeq) {
      let accessToken = getBearerString();
      let headers = {
        Authorization: accessToken,
      };

      console.log(`${root_url}/api/admin/applicant/findby?joinSeq=${joinSeq}`);
      axios({
        method: "get",
        url: `${root_url}/api/admin/applicant/findby?joinSeq=${joinSeq}`,
        headers: headers,
      })
        .then((res) => {
          if (res.status === 200) {
            const { data } = res;
            const { applicant, runnersByTicketType } = data;
            // group 접수인지 확인
            if (applicant.exponent === null) {
              alert("단체 접수자가 아닙니다. 개인 접수로 이동합니다.");
              window.location.href = "/admin/reception/application/individual?joinSeq=" + joinSeq;
              return;
            }
            setIsEditMode(true);
            setExponent(applicant.exponent);
            setJoinerName(applicant.joinerName);
            setJoinerPhoneNum(applicant.cellphone);
            setJoinerSeq(applicant.joinSeq);
            setJoinerPaymentStatus(applicant.paymentStatus);
            setJoinerPaymentType(applicant.paymentType);
            const roadAddress =
              applicant.zipAddress.indexOf("(") >= 0
                ? applicant.zipAddress.split("(")[0]
                : applicant.zipAddress.split("(")[0];
            const buildingName =
              applicant.zipAddress.indexOf("(") >= 0
                ? applicant.zipAddress.split("(")[1].slice(0, -1)
                : "";
            console.log(roadAddress);
            setAddress({
              zonecode: applicant.zipcode,
              roadAddress: roadAddress,
              buildingName: buildingName,
            });
            setDetailAddress(applicant.address);
            //set runner data
            const runner_list = [];
            for (let runners in runnersByTicketType) {
              runner_list.push(...runnersByTicketType[runners]);
            }
            console.log(runner_list);
            setRunnerList(runner_list);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.status === 403) {
            alert("권한이 존재하지 않습니다.");
            localStorage.setItem("accessToken", "");
            window.location.href = "/admin/login";
          }
        });
    }
    else {
      setIsEditMode(false);
      setExponent("");
      setJoinerName("");
      setJoinerPhoneNum("");
      setJoinerPaymentStatus("");
      setJoinerPaymentType("");
      setAddress({
        zonecode: "",
        roadAddress: "",
        buildingName: "",
      });
      setDetailAddress("");
      setRunnerList([]);
    }
  }, [joinSeq]);

  useEffect(() => {
    axios({
      method: "get",
      url: `${root_url}/api/join/ticket-info`,
    })
      .then((res) => {
        if (res.status === 200) {
          let { data } = res;
          console.log(data);
          setTicketInfo(
            data.filter((ticket) => ticket.ticketType === "offline")
          );
          //giftOptionList를 ticketInfo에서 가져옴
          setGiftOptoinList(data[0].choiceOption.split(","));
        }
      })
      .catch((err) => {
        if (err.response.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
      });
  }, []);

  const onSubmitFile = () => {
    console.log(`${root_url}/api/admin/application/excel`);
    console.log(selectedFile);
    if (selectedFile === null) {
      alert("파일을 선택해주세요.");
      return;
    }
    const formData = new FormData();
    let accessToken = getBearerString();
    formData.append("file", selectedFile);
    axios({
      method: "post",
      url: `${root_url}/api/admin/application/excel`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: accessToken,
      },
    })
      .then((res) => {
        //need change to Runner Class
        const new_list = [...runnerList];
        res?.data?.forEach((element) => {
          const runner = new Runner(
            null, //runnerSeq는 처음에 null..?
            element.ticketSeq,
            "티셔츠",
            element.choiceOption,
            element.runnerName,
            element.birthday,
            element.gender,
            element.cellphone,
            joinSeq
          );
          new_list.push(runner);
        });
        setRunnerList(new_list);
        alert(res.data.length + "명의 정보가 입력되었습니다.");
        // console.log(res.data);
      })
      .catch((e) => console.log(e));
  };
  const checkRunnerInfo = () => {
    //runner 추가할때

    //1. insList에 추가(runnerSeq와 상관 없음)

    console.log(
      `${runnerName}, ${runnerBirthday}, ${runnerGender}, ${runnerPhoneNum}, ${runnerCourse}, ${runnerGift}, ${runnerGiftOption}`
    );
    const new_runner = new Runner(
      null,
      parseInt(runnerCourse) + 1,
      "티셔츠",
      runnerGiftOption,
      runnerName,
      runnerBirthday,
      runnerGender,
      runnerPhoneNum,
      joinSeq
    );
    const new_runner_list = [...runnerList, new_runner];
    setInsRunnerList((runnerList) => [...runnerList, new_runner]);
    setRunnerList(new_runner_list);
    //form 비우기
    setRunnerName("");
    setRunnerBirthday("");
    setRunnerPhoneNum("");
  };
  const updateRunnerInfo = () => {
    //폼 수정을 눌렀을 때,

    console.log(onUpdateRunnerInd);
    const new_runner_list = [...runnerList];
    console.log("runnerCourse : " + runnerCourse);
    console.log(ticketInfo[runnerCourse]);
    const runnerSeq = runnerList[onUpdateRunnerInd].runnerSeq;
    new_runner_list[onUpdateRunnerInd] = new Runner(
      runnerSeq || null,
      parseInt(runnerCourse) + 1,
      "티셔츠",
      runnerGiftOption,
      runnerName,
      runnerBirthday,
      runnerGender,
      runnerPhoneNum,
      joinSeq
    );
    //1. runnerSeq가 있고 기존에 없는 경우에만 updRunnerList에 추가
    console.log("========>runnerSEQ" + runnerSeq);
    if (new_runner_list[onUpdateRunnerInd] && runnerSeq !== null) {
      console.log(updRunnerList.indexOf(runnerSeq));
      if (updRunnerList.indexOf(runnerSeq) === -1)
        setUpdRunnerList((list) => [...list, runnerSeq]);
    }
    //1-1. ins_list에 들어가야하는 경우, (추가하고 수정한 경우)
    else {
      const new_list = [...insRunnerList];
      const ind = insRunnerList.indexOf(runnerList[onUpdateRunnerInd]);
      console.log("=====>" + ind);
      new_list[ind] = new_runner_list[onUpdateRunnerInd];
      console.log(new_runner_list[onUpdateRunnerInd]);
      setInsRunnerList(new_list);
    }
    //2. runnerList 수정
    console.log(new_runner_list);
    setRunnerList(new_runner_list);
    //form 비우고, 추가 가능하도록 수정
    setRunnerName("");
    setRunnerBirthday("");
    setRunnerPhoneNum("");
    setOnUpdate(false);
  };
  const onUpdateRunner = (name, cellphone, birthday) => {
    console.log(`onUpdateRunner : ${name}, ${cellphone}, ${birthday}`);
    //참가자 정보를 수정할 때 호출
    //수정 버튼을 누르면 editRunner가 활성화 되며, 해당하는 runner 정보가 form에 들어가서 수정을 가능하게 한다
    //만약, 수정 완료를 하면 해당 참가자 정보에 반영이 되도록 한다
    setOnUpdate(true);
    //1. 해당 name, cellphone인 참가자를 찾는다
    const runnerInd = runnerList.findIndex(
      (runner) =>
        runner.runnerName === name &&
        runner.cellphone === cellphone &&
        runner.birthday === birthday
    );
    setOnUpdateRunnerInd(runnerInd);
    const runnerWillUpd = runnerList[runnerInd];
    console.log(runnerWillUpd);
    //2. 해당 runner의 정보를 form에 넣어준다
    setRunnerName(runnerWillUpd.runnerName);
    setRunnerBirthday(runnerWillUpd.birthday);
    setRunnerGender(runnerWillUpd.gender);
    setRunnerPhoneNum(runnerWillUpd.cellphone);
    setRunnerCourse(runnerWillUpd.ticketSeq - 1);
    setRunnerGiftOption(runnerWillUpd.choiceOption);
    console.log(
      `${runnerWillUpd.gender}, ${runnerWillUpd.cellphone}, ${runnerWillUpd.ticketSeq - 1
      }, ${runnerWillUpd.choiceOption}`
    );
  };
  const onDeleteRunner = () => {
    //삭제하기를 눌렀을 때,

    //1. delRunnerList에 runnerSeq가 있는 경우에만 runner 추가
    for (let i in runnerList) {
      if (runnerList[i].runnerSeq && checkRunnerInd[i]) {
        setDelRunnerList((list) => [...list, runnerList[i]]);
      }
    }
    //1-2. 만약 insRunnerList에 있었다면 해당 삭제
    for (let i in checkRunnerInd) {
      if (checkRunnerInd[i] && insRunnerList.indexOf(runnerList[i]) >= 0) {
        console.log("ins list 에서 지워야함");
        setInsRunnerList((list) =>
          list.filter((runner) => runner !== runnerList[i])
        );
      }
    }
    //2. runnerList 수정
    setRunnerList((runnerList) =>
      runnerList.filter((runner, k) => !checkRunnerInd[k] && runner)
    );
    setCheckRunnerInd(
      (check_list) => check_list.filter((runner, k) => !runner && true) //check 안된 애들만 남기기
    );
  };
  const onUpdateApply = () => {
    //수정하기를 눌렀을 때,
    const joiner = setJoiner(
      ticketInfo,
      runnerList,
      exponent,
      joinerName,
      joinerPhoneNum,
      address,
      detailAddress,
      joinerSeq
    );
    const ins_list = [];
    insRunnerList.map((runner) => ins_list.push(runner));
    const upd_list = [];
    for (let i in runnerList) {
      if (updRunnerList.indexOf(runnerList[i].runnerSeq) >= 0) {
        upd_list.push(runnerList[i]);
      }
    }
    const del_list = [...delRunnerList];
    axios.interceptors.request.use((request) => {
      console.log("Starting Request", JSON.stringify(request, null, 2));
      return request;
    });
    let accessToken = getBearerString();
    axios({
      method: "post",
      url: `${root_url}/api/admin/applicant/applyForAll`,
      data: {
        applicant: joiner,
        runners: {
          INS: [...ins_list],
          DEL: [...del_list],
          UPD: [...upd_list],
        },
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
    })
      .then((res) => {
        console.log(res);
        alert("수정이 완료되었습니다. 결제상태도 초기화됩니다.");
      })
      .catch((e) => {
        if (e.response.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }

        if (e.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          alert(e.response.data.errorMessage);
        }
      });
  };
  const onApply = () => {
    //접수하기를 눌렀을 때,
    const joiner = setJoiner(
      ticketInfo,
      runnerList,
      exponent,
      joinerName,
      joinerPhoneNum,
      address,
      detailAddress
    );
    //runners
    let runners = runnerList;
    console.log(joiner, runners);
    axios({
      method: "post",
      url: `${root_url}/api/applicant/applyFor`,
      data: { joiner, runners },
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        console.log(res);
        const { data } = res;
        if (res.status === 200) {
          alert("접수가 완료되었습니다");
          window.location.href = "/admin/reception/receptionist?pageNo=1&rowCount=10";
        }
      })
      .catch((e) => {
        if (e.response.status === 403) {
          alert("권한이 존재하지 않습니다.");
          localStorage.setItem("accessToken", "");
          window.location.href = "/admin/login";
        }
        if (e?.response === undefined) {
          alert(
            "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
          );
        } else {
          console.log(e);
          if (e?.response?.data?.errorCode === "S0003") {
            // 해당 종목은 매진되었습니다.
            let alert_str = "";
            let full_ticket_set = new Set();
            const msgObj = JSON.parse(e.response.data.errorMessage);
            msgObj.data.map((runner) => full_ticket_set.add(runner.ticketName));
            full_ticket_set.forEach((el) => (alert_str += `${el},`));
            alert(`${alert_str} 해당 종목은 매진되었습니다.`);
          } else if (e?.response?.data?.errorCode === "S0004") {
            // 이미 신청 완료 되었습니다.
            let alert_str = "";
            const msgObj = JSON.parse(e.response.data.errorMessage);
            msgObj.data.map((runner) => (alert_str += `${runner.runnerName},`));
            alert(`${alert_str} 님은 이미 신청 완료 되었습니다.`);
          }
        }
        console.log(e?.response);
        //중복등으로 에러가 난 경우에는 status에 따라 적당히 유도를 해줘야한다.
      });
  };
  return (
    <Container>
      <h1>{isEditMode ? "대리 수정(단체)" : "대리 접수(단체)"}</h1>
      <Row className="text-md-center text-start text-custom-color mb-5 mt-5">
        <h3>접수자 정보</h3>
      </Row>
      {
        isEditMode && (
          <>
            <Form.Label className="fw-bold text-secondary">접수번호</Form.Label>
            <input
              type="number"
              className="form-in-class"
              value={joinSeq}
              disabled
            />
            <Form.Label className="fw-bold text-secondary">결제 상태</Form.Label>
            <input
              type="text"
              className="form-in-class"
              value={joinerPaymentStatus === "CMPL" ? "입금완료" : joinerPaymentStatus === 'CNCL' ? "참가취소" : "입금대기"}
              disabled
            />
            <Form.Label className="fw-bold text-secondary">결제 방법</Form.Label>
            <input
              type="text"
              className="form-in-class"
              value={joinerPaymentType === 'BANK' ? '계좌이체' : '카드결제'}
              disabled
            />
          </>
        )
      }
      <Form.Label className="fw-bold">단체명</Form.Label>
      <input
        type="text"
        className="form-in-class"
        placeholder="대덕구체육회"
        value={exponent}
        onChange={(e) => setExponent(e.target.value)}
      />
      <Form.Label className="fw-bold">이름</Form.Label>
      <input
        type="text"
        className="form-in-class"
        placeholder="홍길동"
        value={joinerName}
        onChange={(e) => setJoinerName(e.target.value)}
      />
      <Form.Label className="fw-bold">전화번호(-제외 11자 이내)</Form.Label>
      <input
        type="number"
        className="form-in-class"
        placeholder="01012345678"
        value={joinerPhoneNum}
        onChange={(e) => setJoinerPhoneNum(e.target.value)}
      />
      <Form.Label className="fw-bold">주소</Form.Label>
      <Row>
        <Col>
          <Form.Control
            type="text"
            placeholder="우편번호"
            value={address.zonecode}
            onClick={() => setPopupShow((popupShow) => !popupShow)}
            onChange={() => console.log("")}
          />
        </Col>
        <Col>
          <Button
            className="border bg-custom-color mb-4"
            onClick={() => setPopupShow((popupShow) => !popupShow)}
          >
            우편번호 찾기
          </Button>
        </Col>
      </Row>

      <Form.Control
        type="text"
        placeholder="주소"
        // onClick={() => setPopupShow(!popupShow)}
        value={
          address.roadAddress &&
          `${address.roadAddress}(${address.buildingName})`
        }
        onChange={() => {
          console.log("");
        }}
        className="mb-4"
      />
      <input
        type="text"
        className="form-in-class"
        placeholder="상세주소"
        value={detailAddress}
        onChange={(e) => {
          setDetailAddress(e.target.value);
        }}
      />

      <Row className="text-md-center text-start text-custom-color mb-5 mt-5">
        <h3>참가자 정보</h3>
      </Row>
      <input
        type="file"
        onChange={(e) => setSelectedFile(e.target.files[0])}
        accept=".xls, .xlsx"
      />
      <Button onClick={onSubmitFile}>파일 업로드</Button>
      <h3 className="mt-5 mb-5">총 {runnerList.length}명</h3>
      <Container>
        <div style={{ overflowX: "scroll", margin: 0 }}>
          <Table style={{ minWidth: "900px" }}>
            <thead>
              <tr>
                <th width={"12%"}>이름</th>
                <th width={"12%"}>생년월일</th>
                <th width={"10%"}>성별</th>
                <th width={"14%"}>전화번호</th>
                <th width={"18%"}>종목</th>
                <th>기념품</th>
                <th>기념품 옵션</th>
                <th width={"10%"}></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {/* 참가자 이름 : runnerName */}
                  <input
                    type="text"
                    className="form-in-class"
                    placeholder="홍길동"
                    value={runnerName}
                    onChange={(e) => {
                      setRunnerName(e.target.value);
                    }}
                  />
                </td>
                <td>
                  {/* 생년월일 :  runnerBirthday */}
                  <input
                    type="number"
                    className="form-in-class"
                    placeholder="19990320"
                    value={runnerBirthday}
                    onChange={(e) => {
                      setRunnerBirthday(e.target.value);
                    }}
                  />
                </td>
                <td>
                  {/* 성별 : runnerGender */}
                  <select
                    value={runnerGender}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setRunnerGender(e.target.value);
                    }}
                    className="custom-select"
                  >
                    <option value="M">남</option>
                    <option value="F">여</option>
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    className="form-in-class"
                    placeholder="01012345678"
                    value={runnerPhoneNum.replaceAll("-", "")}
                    onChange={(e) => {
                      setRunnerPhoneNum(e.target.value);
                    }}
                  />
                </td>
                <td>
                  {/* 신청 종목 : runnerCourse */}
                  {/* 신청가능한 날인지, 품절되진 않았는지 */}
                  <select
                    value={runnerCourse}
                    onChange={(e) => {
                      console.log("participantCourse : " + e.target.value);
                      setRunnerCourse(e.target.value);
                      // setParticipantGift("0");
                    }}
                    className="custom-select"
                  >
                    {ticketInfo.map((ticket, key) => (
                      <option
                        value={ticket.ticketSeq - 1}
                        key={ticket.ticketSeq}
                      >
                        {ticket.ticketName}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  {/* 기념품 : runnerGift */}
                  <select value={runnerGift}>
                    <option>티셔츠</option>
                  </select>
                </td>
                <td>
                  {/* 기념품 옵션 : runnerGiftOption */}
                  <select
                    value={runnerGiftOption}
                    onChange={(e) => setRunnerGiftOption(e.target.value)}
                  >
                    {giftOptionList.map((souv, key) => (
                      <option key={souv}>{souv}</option>
                    ))}
                  </select>
                </td>
                <td>
                  {onUpdate ? (
                    <Button
                      style={{ fontSize: "0.7rem" }}
                      onClick={() => updateRunnerInfo()}
                    >
                      수정완료
                    </Button>
                  ) : (
                    <Button
                      style={{ fontSize: "0.7rem" }}
                      onClick={() => checkRunnerInfo()}
                    >
                      추가
                    </Button>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
        <Row className="text-start text-custom-color mb-5 mt-5">
          <h3>참가자 목록</h3>
        </Row>
        <div style={{ overflowX: "scroll", margin: 0 }}>
          <Table style={{ minWidth: "900px" }}>
            <thead>
              <tr>
                <th>
                  <Button onClick={onDeleteRunner}>삭제</Button>
                </th>
                <th width={"12%"}>이름</th>
                <th width={"12%"}>생년월일</th>
                <th width={"10%"}>성별</th>
                <th width={"14%"}>전화번호</th>
                <th width={"18%"}>종목</th>
                <th>기념품</th>
                <th>기념품 옵션</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {runnerList?.map((runner, key) => (
                <tr key={key}>
                  <td>
                    <input
                      type="checkbox"
                      checked={checkRunnerInd[key] ? true : false}
                      value={checkRunnerInd[key] ? true : false}
                      onChange={() => {
                        console.log("checked :" + checkRunnerInd[key]);
                        const new_list = checkRunnerInd;
                        for (let i in checkRunnerInd) {
                          if (i == key) new_list[i] = !new_list[i];
                        }
                        // new_list[key] = e.target.checked;
                        console.log(new_list);
                        setCheckRunnerInd([...new_list]);
                      }}
                    />
                  </td>
                  <td>{runner.runnerName}</td>
                  <td>{runner.birthday}</td>
                  <td>{runner.gender.trim() === "M" ? "남" : "여"}</td>
                  <td>{runner.cellphone}</td>
                  <td>{ticketInfo[runner.ticketSeq - 1]?.ticketName}</td>
                  <td>티셔츠</td>
                  <td>{runner.choiceOption}</td>
                  <td>
                    <Button
                      onClick={() =>
                        onUpdateRunner(
                          runner.runnerName,
                          runner.cellphone,
                          runner.birthday
                        )
                      }
                    >
                      수정
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div>
          {joinSeq ? (
            <Button className="mb-5 mt-3" onClick={onUpdateApply}>
              수정하기
            </Button>
          ) : (
            <Button className="mb-5 mt-3" onClick={onApply}>
              접수하기
            </Button>
          )}
        </div>
      </Container>
      {/* kakao map modal */}
      <Modal
        show={popupShow}
        onHide={() => setPopupShow(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <DaumPostCode onComplete={onCompletePostCode} />
        </Modal.Body>
      </Modal>
    </Container>
  );
};
export default AdminApplicationGroup;
